import * as React from 'react';
import { useState, useEffect } from 'react';
import RelojChecador from '../../../Services/Catalogos/RelojChecador';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo';
import { Button, Card, Form, Col, Row } from 'react-bootstrap';
import { BsSearch, BsFileEarmarkExcel } from 'react-icons/bs';
import { DTOReporteFechas } from '../../Catalogos/CatalogosReloj/DTO/DTOReporteFechas';
import { DTOReporteChecadas } from '../../Catalogos/CatalogosReloj/DTO/DTOReporteChecadas';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export default function RptTotalHoursParaSupervisor() {
    
    const [inicio, setInicio] = useState<string>(currentDate());
    const [fin, setFin] = useState<string>(currentDate());
    const [filtro, setFiltro] = useState<string>('');
    const [data, setData] = useState<Array<DTOReporteFechas>>([]);
    const [filteredData, setFilteredData] = useState<Array<DTOReporteFechas>>([]);
    const [detalleData, setDetalleData] = useState<Array<DTOReporteChecadas>>([]);
    
    
    const [showToast, setShowToast] = useState<boolean>(false);
    const [toastMsg, setToastMsg] = useState<string>('');
    const [toastHeader, setToastHeader] = useState<string>('');
    const [toastColor, setToastColor] = useState<string>('');

   
    const getSupervisorId = () => {
        let storedUserId = localStorage.getItem("IdSupervisorPropio")?.replace(/['"]+/g, '');
        return storedUserId || null;
    };

    const generarReporte = () => {
        const idSupervisor = getSupervisorId();

        if (!idSupervisor) {
            setToastMsg('No se encontró ID de Supervisor en el sistema.');
            setToastHeader('Error de sesión');
            setToastColor('danger');
            setShowToast(true);
            return;
        }

        let errorMessages: string[] = [];

        
        RelojChecador.getEntradasSalidasFechasSupervisor(idSupervisor, inicio, fin)
            .then((response) => {
                setData(response.data);
                setFilteredData(response.data);
                setToastMsg('Reporte actualizado correctamente');
                setToastHeader('Éxito');
                setToastColor('success');
                setShowToast(true);
            })
            .catch(() => errorMessages.push('Error al obtener resumen de horas'));

        
        RelojChecador.getReporteChecadasSupervisor(idSupervisor, inicio, fin)
            .then((response) => {
                setDetalleData(response.data);
            })
            .catch(() => errorMessages.push('Error al obtener detalle de checadas'));

        if (errorMessages.length > 0) {
            setToastMsg(errorMessages.join(' | '));
            setToastHeader('Atención');
            setToastColor('warning');
            setShowToast(true);
        }
    };

    
    useEffect(() => {
        generarReporte();
    }, []);

    function currentDate(): string {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const yyyy = today.getFullYear();
        return `${yyyy}-${mm}-${dd}`;
    }

    const columns = [
        // { name: 'ID', width: '80px', selector: (row: DTOReporteFechas) => row.userId, sortable: true },
        { name: 'No. Emp', width: '100px', selector: (row: DTOReporteFechas) => row.numeroEmpleado, sortable: true },
        { name: 'Nombre', width: '250px', selector: (row: DTOReporteFechas) => row.nombreEmpleado, sortable: true },
        // { name: 'Departamento', width: '180px', selector: (row: DTOReporteFechas) => row.departamento },
        { name: 'HEntrada', width: '100px', selector: (row: DTOReporteFechas) => row.horaEntrada },
        { name: 'Hrs Totales', width: '100px', selector: (row: DTOReporteFechas) => row.totalHoras },
        { name: 'Hrs Extras', width: '100px', selector: (row: DTOReporteFechas) => row.horasExtras },
        { name: 'Retardos', width: '100px', selector: (row: DTOReporteFechas) => row.totalRetardos },
        { name: 'Faltas', width: '80px', selector: (row: DTOReporteFechas) => row.totalFaltas }
        
    ];

    const filtraReporte = (e: React.ChangeEvent<HTMLInputElement>) => {
        const searchText = e.target.value.toLowerCase();
        setFiltro(searchText);
        const filtered = data.filter((item) =>
            item.numeroEmpleado.toLowerCase().includes(searchText) ||
            item.nombreEmpleado.toLowerCase().includes(searchText)
        );
        setFilteredData(filtered);
    };

    // const exportExcel = () => {
    //     const wb = XLSX.utils.book_new();
        
        
    //     const wsResumen = XLSX.utils.json_to_sheet(filteredData);
    //     XLSX.utils.book_append_sheet(wb, wsResumen, 'Resumen_Supervisor');

        
    //     const wsDetalle = XLSX.utils.json_to_sheet(detalleData);
    //     XLSX.utils.book_append_sheet(wb, wsDetalle, 'Detalle_Checadas');

    //     XLSX.writeFile(wb, `Reporte_Supervisor_${inicio}_al_${fin}.xlsx`);
    // };



const exportExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const idSupervisor = localStorage.getItem("IdSupervisorPropio")?.replace(/['"]+/g, '') || "N/A";
    const nombreArchivo = `Reporte_Asistencia_Supervisor_${idSupervisor}_${inicio}_al_${fin}.xlsx`;

    // --- HOJA 1: RESUMEN SEMANAL ---
    const worksheet = workbook.addWorksheet('Resumen_Supervisor');

    // 1. LOGO (Opcional si existe en /public)
    try {
        const response = await fetch('/GEMCO.png');
        if (response.ok) {
            const blob = await response.blob();
            const arrayBuffer = await blob.arrayBuffer();
            const logoId = workbook.addImage({
                buffer: arrayBuffer,
                extension: 'png',
            });
            worksheet.addImage(logoId, { tl: { col: 0.1, row: 0.1 }, ext: { width: 95, height: 55 } });
        }
    } catch (e) { console.warn("Logo no disponible"); }

    // 2. ENCABEZADOS DE IDENTIFICACIÓN
    worksheet.mergeCells('C1:J1');
    const title = worksheet.getCell('C1');
    title.value = 'GLAFIRO E. MONTEMAYOR Y CIA S.C.';
    title.font = { bold: true, size: 14 };
    title.alignment = { horizontal: 'center' };

    worksheet.getCell('A4').value = 'Módulo:';
    worksheet.getCell('B4').value = 'Reporte de Asistencia Semanal (Supervisor)';
    worksheet.getCell('A5').value = 'Fecha:';
    worksheet.getCell('B5').value = `Del ${inicio} al ${fin}`;
    
    worksheet.getCell('B6').font = { bold: true };

    // 3. HEADERS DE TABLA
    const headerRowIdx = 8;
    const headers = [ 'NO. EMPLEADO', 'NOMBRE DEL EMPLEADO',  'ENTRADA TAB.', 'TOT. HORAS', 'EXTRAS', 'FALTAS', 'RETARDOS'];
    const headerRow = worksheet.getRow(headerRowIdx);
    
    headers.forEach((h, i) => {
        const cell = headerRow.getCell(i + 1);
        cell.value = h;
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0E0E0' } };
        cell.font = { bold: true, size: 10 };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    // 4. VOLCADO DE DATOS (Filtrados)
    let currentRow = 9;
    filteredData.forEach(emp => {
        const row = worksheet.getRow(currentRow);
        row.values = [
            
            emp.numeroEmpleado,
            emp.nombreEmpleado,
            
            
            emp.horaEntrada,
            emp.totalHoras,
            emp.horasExtras,
            emp.totalFaltas,
            emp.totalRetardos
        ];

        // Estilos por celda
        row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber <= 10) {
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                cell.font = { size: 9 };
                cell.alignment = { horizontal: colNumber === 3 ? 'left' : 'center' };
            }
        });
        currentRow++;
    });

    // Ajuste de anchos
    worksheet.getColumn(3).width = 40; // Nombre
    worksheet.getColumn(4).width = 25; // Departamento
    worksheet.getColumn(5).width = 20; // Oficina

    // --- HOJA 2: DETALLE_CHECADAS ---
    const wsDetalle = workbook.addWorksheet('Detalle_Checadas');
    
    // Header Detalle
    const detHeaders = [ 'No. Empleado', 'Nombre', 'Fecha', 'Entrada 1', 'Salida 1', 'Entrada 2', 'Salida 2', 'Entrada 3', 'Salida 3', 'Total Horas'];
    const detHeaderRow = wsDetalle.getRow(1);
    detHeaderRow.values = detHeaders;
    detHeaderRow.eachCell(c => {
        c.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4F81BD' } };
    });

    detalleData.forEach(d => {
        wsDetalle.addRow([
             d.numeroEmpleado, d.nombreEmpleado, d.fecha, 
            d.entrada1, d.salida1, d.entrada2, d.salida2, d.entrada3, d.salida3, d.totalHoras
        ]);
    });
    wsDetalle.getColumn(3).width = 35;

    // --- GENERAR ARCHIVO ---
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), nombreArchivo);
};

    return (
        <div className="mt-3 container-fluid">
            <Card className="shadow-sm">
                <Card.Body>
                    <Form>
                        <Row className="align-items-end">
                            <Col md={2}>
                                <Form.Group>
                                    <Form.Label className="small fw-bold">Fecha Inicio</Form.Label>
                                    <Form.Control type="date" value={inicio} onChange={(e) => setInicio(e.target.value)} size="sm" />
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group>
                                    <Form.Label className="small fw-bold">Fecha Fin</Form.Label>
                                    <Form.Control type="date" value={fin} onChange={(e) => setFin(e.target.value)} size="sm" />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="small fw-bold">Filtrar Empleado</Form.Label>
                                    <Form.Control type="text" placeholder="Nombre o número..." onChange={filtraReporte} size="sm" />
                                </Form.Group>
                            </Col>
                            <Col md={4} className="text-end">
                                <Button variant="primary" onClick={generarReporte} size="sm" className="me-2">
                                    <BsSearch /> Buscar
                                </Button>
                                <Button variant="success" onClick={exportExcel} size="sm">
                                    <BsFileEarmarkExcel /> Exportar Excel
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
            </Card>

            <MsgInformativo
                show={showToast}
                msg={toastMsg}
                header={toastHeader}
                msgColor={toastColor}
                closeToast={() => setShowToast(false)}
            />

            <Card className="mt-3 shadow-sm">
                <Card.Body>
                    <DataTable
                        columns={columns}
                        data={filteredData}
                        pagination
                        paginationPerPage={15}
                        striped
                        highlightOnHover
                        dense
                        noDataComponent="No se encontraron registros para este supervisor."
                    />
                </Card.Body>
            </Card>
        </div>
    );
}